const $inject = ['$q', '$http', '$translate', '$window', 'apiService'];

const settingsService = function ($q, $http, $translate, $window, apiService) {
  let service = {};

  service.settings = null;
  service.settingsRequired = true;
  service.settingsLoading = false;
  service.allowNoSettingsForConsultant = false;
  service.getAny = getAny;
  service.get = get;
  service.clear = clear;
  service.isOneWayFare = isOneWayFare;
  service.getRailCards = getRailCards;
  service.currencyCode = currencyCode;
  service.getHotelPaymentNarrativesByIds = getHotelPaymentNarrativesByIds;


  function getAny() {
    if(service.settings) {
      let deferred = $q.defer();
      deferred.resolve(service.settings);
      return deferred.promise;
    } else {
      return get();
    }
  }

  function get() {
    const deferred = $q.defer();
    const apiUrl = apiService.getUrl('settings');

    const request = {};
    request.method = 'GET';
    request.url = apiUrl;
    request.apiVersion = 20;

    service.settingsLoading = true;
    $http(request)
      .then((res) => {
        let data = res.data;
        
        service.settingsLoading = false;
        service.settings = data;
        window.sessionStorage.setItem('NeedsFederatedLogout', data.NeedsFederatedLogout);
        window.sessionStorage.setItem('CarbonEmissionSetting', JSON.stringify(data.CarbonEmissionSetting));
        $window.settings = data;

        if(data.Locale) {
          setLocale(data.Locale);
        }

        if(data.Location) {
          setLocation(data.Location);
        }

        deferred.resolve(data);
      });

    return deferred.promise;
  }

  function clear() {
    service.settings = null;
  }

  function setLocale(localeCode) {
    window.sessionStorage.setItem('i18nCode', localeCode);
    $translate.use(localeCode);
  }

  function setLocation(locationCode) {
    window.sessionStorage.setItem('locationCode', locationCode);
  }

  function isOneWayFare(origin, destination) {
    return _.some(service.settings.FlightConfiguration.OneWayFareRules, rule => {
      return rule.Origin === origin.CountryCode && rule.Destination === destination.CountryCode
    });
  }

  function getRailCards() {
    if(!service.settings.RailConfiguration || !service.settings.RailConfiguration.RailCard) {
      return undefined;
    }

    return service.settings.RailConfiguration.RailCard;
  }

  function currencyCode() {
    return service.settings.Currency.Code;
  }

  function getHotelPaymentNarrativesByIds(codes) {
    return _.filter(service.settings.HotelConfiguration.PaymentNarratives, (narrative) => {
      return _.includes(codes, narrative.PaymentCode);
    });
  }

  return service;
};

settingsService.$inject = $inject;

export default settingsService;



// WEBPACK FOOTER //
// ./src/services/settingsService.js